export const resume = {
  name: "Khang Nguyen",
  education: [
    {
      institution: "University of Ottawa",
      location: "Ottawa, Ontario, Canada",
      degree: "BASc Software Engineering",
      gpa: "9.0",
      dates: "Sept 2017 - Dec 2021"
    }
  ],
  experience: [
    {
      company: "Veeva Systems",
      location: "Toronto, Ontario",
      title: "Software Engineer",
      dates: "Jun 2025 - Present",
      responsibilities: [
        "Designed and led auto suppress weblinks for published content plan documents",
        "Worked on eCTD4.0 validation rules for Japan and US",
        "Worked on eCTD3.2 validation rules",
        "Worked on eCTD3.2 and 4.0 submission XML generation",
        "Worked on eCTD3.2 and 4.0 submission publishing"
      ]
    },
    {
      company: "SSENSE",
      location: "Montreal, Quebec",
      title: "Software Developer",
      dates: "Sep 2021 - Jun 2025",
      responsibilities: [
        "Full stack development, using previous product sale metrics to calculate and surface quantity recommendations to optimize sales and leftover inventory",
        "Designed and led a new sizing experience for company purchase orders, allowing the app to automatically calculate select units to purchase per size",
        "Designed and implemented a flow to surface previous sales statistics on similar products to help user quantify how many products to buy lowering over buys",
        "Designed and led an initiative to move serverless API endpoints into EKS endpoints. Refactored the application layer to support both serverless and EKS endpoints during the switchover",
        "Worked with machine learning algorithms using previous sales data on similar products to recommend quantities for product purchases",
        "Used DataDog to monitor, debug, and investigate systems and incidents using dashboards and queries",
        "Led a feature to seed and live-sync data into a new database, establishing it as the new source of truth",
        "Collaborated closely with users to create EPICs, stories, and tickets and aligned feature development accordingly"
      ]
    },
    {
      company: "Amazon",
      location: "Toronto, Ontario",
      title: "Software Development Engineer",
      dates: "Apr 2021 - Sep 2021",
      responsibilities: [
        "Solely developed and launched an application to surface and visualize inventory levels and paths globally",
        "Enabled optimization of supply chain and selection of ideal warehouse locations",
        "Used Elasticsearch for custom indexing and fast filtering",
        "Worked with Andes, Cradle, S3, Step Functions for data processing",
        "Pitched and explained technical designs and implementation decisions",
        "Worked with stakeholders to determine key data for visualization"
      ]
    },
    {
      company: "NetFore Systems",
      location: "Ottawa, Ontario",
      title: "Software Engineer Intern",
      dates: "Apr 2020 - Sep 2020",
      responsibilities: [
        "Engaged with clients to identify and prioritize important features",
        "Retired Groovy Server Pages (GSP) by migrating server-side templates and logic to React",
        "Added indexes and constraints to PostgreSQL databases to reduce faulty data and improve performance"
      ]
    },
    {
      company: "Interac",
      location: "Ottawa, Ontario",
      title: "Software Analyst Intern",
      dates: "Sep 2019 - Jan 2020",
      responsibilities: [
        "Spearheaded automation for penetration testing using OWASP ZAP",
        "Identified security issues pre-production",
        "Received ISO 27001 training",
        "Created user stories and acceptance criteria"
      ]
    },
    {
      company: "Nokia",
      location: "600 March Rd",
      title: "NSP/MDM Infrastructure Developer",
      dates: "Jan 2019 - Apr 2019",
      responsibilities: [
        "Infrastructure development for NSP/MDM",
        "Developed backend JavaScript tools to translate YANG files to JSON and back",
        "Implemented logic to compare JSON structures to validate data placement",
        "Automated creation and updating of service routers through YANG file manipulation"
      ]
    },
    {
      company: "NRCan",
      location: "580 Booth St",
      title: "Database Developer",
      dates: "Apr 2018 - Aug 2018",
      responsibilities: [
        "Contributed to PostgreSQL database development for the RADARSAT Constellation Mission",
        "Used Java Selenium to test user access permissions for the database",
        "Helped validate data integrity and secure access in a government setting"
      ]
    }
  ],
  skills: {
    programmingLanguages: ["Java", "TypeScript", "JavaScript", "Python"],
    software: ["AWS",
      "Serverless",
      "EKS",
      "Docker",
      "Jenkins",
      "MongoDB",
      "SQL",
      "NodeJS",
      "React",
      "Git", 
      "JIRA",
       "SonarQube",
       "DataDog"
      ]
  }
};
